function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { SelectField, TextField } from '@unite-us/ui';
import { Field } from 'react-final-form';
function DeclinedScreening(_ref) {
  var declineReason = _ref.declineReason,
    onDeclineReasonChange = _ref.onDeclineReasonChange,
    additionalInfo = _ref.additionalInfo,
    onAdditionalInfoChange = _ref.onAdditionalInfoChange,
    options = _ref.options;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "text-base font-semibold mt-4"
  }, "Please provide a reason for the client declining a screening."), /*#__PURE__*/React.createElement(Field, {
    name: "decline_reason_input"
  }, function (params) {
    return /*#__PURE__*/React.createElement(SelectField, _extends({
      id: "decline_reason_input",
      value: declineReason,
      label: "REASON FOR DECLINE",
      postLabelContent: /*#__PURE__*/React.createElement("div", {
        className: "mb-3"
      }, "Select why the client declined this screening."),
      options: options,
      placeholder: "Select a reason",
      autoSelectValue: true,
      className: "mt-5",
      required: true,
      shouldSort: false,
      onChange: onDeclineReasonChange
    }, params));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "additional_information",
    label: "Additional Information",
    afterLabelContent: "Include any additional information about why the client declined",
    value: additionalInfo,
    onChange: onAdditionalInfoChange,
    placeholder: "Enter additional information here"
  })));
}
DeclinedScreening.propTypes = {
  declineReason: PropTypes.string.isRequired,
  onDeclineReasonChange: PropTypes.func.isRequired,
  additionalInfo: PropTypes.string,
  onAdditionalInfoChange: PropTypes.func.isRequired,
  options: PropTypes.array
};
export default DeclinedScreening;
//# sourceMappingURL=DeclinedScreenings.js.map